// middleware/checkPlan.js
import useJwt from "@/auth/jwt/useJwt"; // Adjust the path to your useJwt module

export default async function checkPlancheckPlan(to, from, next) {
  const token = useJwt.getToken();
  try {
    const response = await useJwt.getUserCurrentPlan(token);
    const currentPlan = response.data;

    if (!currentPlan.active) {
      next("/my-plans");
    } else {
      next();
    }

    next(); // Proceed to the route if the check passes
  } catch (error) {
    console.log(error);
    next(); // Optionally proceed to the route even if there is an error
  }
}
